import { resolvePageContext } from './resolve-page-context.util'

function hasValue(value) {
  if (value === null || value === undefined)
    return false

  if (typeof value === 'string')
    return value.trim() !== ''

  return true
}

export function mapUserSession({ route, authStore, extraContext = {} } = {}) {
  const routePath = route?.path || ''
  const pageContext = resolvePageContext(route)
  const tenantName = authStore?.tenantData?.tenantName || authStore?.tenantData?.name || null

  const {
    businessunit_id = null,
    businessunit_name = '',
    businessarea_id = null,
    businessarea_name = '',
    country = '',
    site_id = null,
    site_name = '',
    area_id = null,
    area_name = '',
    route_id = null,
    route_name = '',
    businessmacroprocess_id = null,
    businessmacroprocess_name = '',
    businessprocess_id = null,
    businessprocess_name = '',
    businessactivity_id = null,
    businessactivity_name = '',
  } = extraContext

  const mappedUserSession = {
    route_name: pageContext.title || route?.name,
    route_path: routePath,
    module: pageContext.module,
    user_id: authStore?.userData?.id ?? null,
    user_uuid: authStore?.userData?.uuid ?? null,
    default_site_id: authStore?.userData?.defaultSite?.id ?? authStore?.userData?.defaultSite?._id ?? null,
    default_site_name: authStore?.userData?.defaultSite?.name ?? null,
    roles: Array.isArray(authStore?.userRoles) ? [...authStore.userRoles] : null,
    selected_area: authStore?.userData?.selectedArea ?? null,
    selected_mananger: authStore?.userData?.selectedManager ?? null,
    company_id: authStore?.companyData?.id ?? null,
    company_name: authStore?.companyData?.name ?? null,
    tenant_id: authStore?.tenantData?.id ?? null,
    tenant_name: tenantName,
    economic_group: authStore?.tenantData?.economicGroup ?? null,
  }

  const optionalContext = {
    businessunit_id,
    businessunit_name,
    businessarea_id,
    businessarea_name,
    country,
    site_id,
    site_name,
    area_id,
    area_name,
    route_id,
    route_name,
    businessmacroprocess_id,
    businessmacroprocess_name,
    businessprocess_id,
    businessprocess_name,
    businessactivity_id,
    businessactivity_name,
  }

  Object.entries(optionalContext).forEach(([key, value]) => {
    if (hasValue(value))
      mappedUserSession[key] = value
  })

  return mappedUserSession
}
